export default __webpack_public_path__ + "7c551cd4185d5ccad6eb8232c71d8feb.svg";